import { render, staticRenderFns } from "./dev-show-attributes.vue?vue&type=template&id=3da39814"
import script from "./dev-show-attributes.vue?vue&type=script&lang=js"
export * from "./dev-show-attributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports